<template>
    <div class="pageDate mdc-elevation--z10" v-bind:class="this.zoomed?'zoomed':''">

        <div v-if="page" class="left-right">
            <div class="left">



                <h1>
                    <span>
                        <edit-text v-model="page.date"></edit-text>
                    </span>
                </h1>
                <h2><edit-text v-model="page.titleTrad"></edit-text></h2>
                <p><edit-text v-model="page.textTrad"></edit-text></p>
            </div>
            <div class="right">
                <img :src="page.imgSrc" :alt="page.legendeTrad">
                <legende-deco v-if="page.legende[$store.state.language]">{{page.legende[$store.state.language]}}</legende-deco>
            </div>
        </div>

        <nav>
            <a v-if="page.prev()" is="router-link" :to="page.prev().url($store.state.language)"
               class="prev">
                <icon-base size="4vw" icon-color="#fff">
                    <icon-caret-left/>
                </icon-base>
            </a>

            <a v-if="page.next()"  is="router-link" :to="page.next().url($store.state.language)"
               class="next">
                <icon-base size="4vw" icon-color="#fff">
                    <icon-caret-right/>
                </icon-base>
            </a>

            <a class="zoom2" href="#" v-on:click.prevent="zoomed=!zoomed">
                <icon-base icon-color="#fff" size="3vw">
                    <icon-zoom/>
                </icon-base>
            </a>

            <a class="zoom" href="#" v-on:click.prevent="zoomed=!zoomed" >
                <icon-base size="4vw" icon-color="var(--text-color)">
                    <icon-close/>
                </icon-base>
            </a>

            <a v-if="!zoomed" class="close" href="#"  v-on:click.prevent="$router.push('/')">
                <icon-base size="3vw" icon-color="var(--text-color)">
                    <icon-close/>
                </icon-base>
            </a>

        </nav>

    </div>

</template>

<script>

    import IconBase from "shared-src/icons/IconBase";
    import IconCaretLeft from "shared-src/icons/IconCaretLeft";
    import IconClose from "shared-src/icons/IconClose";
    import IconZoom from "shared-src/icons/IconZoom";
    import IconCaretRight from "shared-src/icons/IconCaretRight";
    import EditText from "@/components/wysiwyg/EditText";
    import LegendeDeco from "shared-src/comp/LegendeDeco";

    export default {
        name: "PageDate",
        data(){
            return {
                /**
                 * @type {PageDataModel}
                 */
                page:null,
                zoomed:false,
                edit:{
                    date:false
                }
            }
        },
        components:{
            EditText,
            IconBase,
            IconZoom,
            IconClose,
            IconCaretLeft,
            IconCaretRight,
            LegendeDeco,

        },
        created(){
          this.fetchData();
          this.resetDisplay();
        },
        watch: {
            '$route': ['fetchData','resetDisplay']
        },
        methods:{
            fetchData () {
                this.page=this.$store.getters.getPageById(this.$route.params.id);
            },
            resetDisplay(){
                this.zoomed=false
            }

        }
    }
</script>

<style scoped lang="less">
    .pageDate{
        //user-select: none;
        --text-color: #54413D;
        //position: relative;


        .left-right{
            width: 100%;
            height: 100%;
            position: relative;
            .left,.right{
                position: absolute;
                height: 100%;
                width: 50%;
            }
            .left{
                color: var(--text-color);
                background-color: #FDF9EE;
                overflow-y: auto;
            }
            .right{
                right: 0;
            }
        }
        .right{
            position: relative;
            img{
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .legende-deco{
                position: absolute;
                bottom: 1vw;
                text-align: center;
                width: 100%;
            }
        }
        .left{
            >*{
                margin: 0;
            }
            h1{
                margin-top: 8vw;
                //line-height: 0;
                >span{
                    position: relative;
                    display: inline-block;
                    line-height: 1.1;
                    &:after{
                        content: "";
                        display: block;
                        margin-top: 1vw;
                        border-top: 4px solid;
                        width: calc( 100% + 1.3vw);
                        height: 1px;
                    }
                }


            }
            h2{
                margin-top: 1vw;
            }
            >h1,h2{
                margin-left: 8vw;
                margin-right: 4vw;
            }
            p{
                margin-top: 2vw;
                margin-left: 10vw;
                margin-right: 6vw;
            }
        }

        nav{

            --icon-size:4vw;
            pointer-events: none;
            *{
                pointer-events: auto;
            }
            position: absolute;
            top:0;
            left:0;
            width: 100%;
            height: 100%;

            svg{
                pointer-events: none;
                //width: var(--icon-size);
                //height:var(--icon-size);
            }

            >*{
                position: absolute;
                //color: #fff;
            }
            .prev,.next{
                top:calc(50% -  var(--icon-size) / 2);
            }
            .prev{
                left:calc( -1 * var(--icon-size) - 1vw);
            }
            .next{
                right:calc( -1 * var(--icon-size) - 1vw);
            }
            .close{
                --icon-size:3vw;
                width: var(--icon-size);
                height: var(--icon-size);
                color: var(--text-color);
                top: 1.2vw;
                left: 1.2vw;
            }
            .zoom2{
                top: 1.2vw;
                right: 1.2vw;

            }
            .zoom{
                display: none;
                top: 0;
                right: 0;
                background-color: white;
                padding: 0;
                color: #000;
                border: none;
                width: var(--icon-size);
                height: var(--icon-size);

            }


        }


    }

    .right{
        transition: all 0.5s;
    }

    .zoom{
        >*{
            transition: all 0.5s;
            transform: rotate(45deg) scale(0.75);
            display: block;
        }
    }
    .zoomed{
        .zoom{
            >*{
                transform: rotate(0deg);
            }
        }
        .right{
            width: 100% !important;
        }
    }

</style>